/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const fullPageCelebrationTokens = {
  CoreTextColor: '#1c2222',
  CoreBackgroundColor: '#fbf8f7',
} as const;
